import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SERVICE_END_POINT, UtilService, AnalyticsService } from 'src/app/shared';

@Component({
  selector: 'app-un-supported-browser',
  templateUrl: './un-supported-browser.component.html',
  styleUrls: ['./un-supported-browser.component.scss']
})
export class UnSupportedBrowserComponent implements OnInit {
  protected contentDataunsupportedBrowser: any;
  protected contentDataunsupportedResolution: any;
  public errorType:string;

  public CMSData;
  constructor(private activatedRoute: ActivatedRoute, private utilService: UtilService,
    private analyticsService:AnalyticsService) { 
    this.contentDataunsupportedBrowser = this.activatedRoute.snapshot.data.contentData.unsupportedBrowser;
    this.contentDataunsupportedResolution = this.activatedRoute.snapshot.data.contentData.unsupportedResolution;
  }

  ngOnInit() {
    this.GetCMSDataService();
    this.analyticsService.pageTrack({ pageName: "Screen size error" });
    this.activatedRoute.paramMap.subscribe(param=>{
     this.errorType = param.get('type');

    })
  }
  
/** Code block for CMS */
GetCMSDataService() {
  //console.log('original value = ', );
  const URL =  SERVICE_END_POINT.higherEnvironment.CMS_Unsupported;
  this.utilService.getCMSData(URL)
  .subscribe(res => {
    //console.log('2 GetCMSDataService => ', res);
    this.CMSData = res;
    if(this.CMSData) {
    /** In the line below we are over-writing the contentData object values with CMSData object values */
      this.contentDataunsupportedBrowser.header = this.CMSData.string_BrowserNotSupportedTitle;
      this.contentDataunsupportedBrowser.Detail = this.CMSData.stringGroup_BrowserNotSupportedText;
      this.contentDataunsupportedResolution.header = this.CMSData.string_ResolutionNotSupportedTitle;
      this.contentDataunsupportedResolution.Detail = this.CMSData.string_ResolutionNotSupportedText;
      //console.log('changed value = ', );
    }
  });
}

/** End of code block for CMS */

}
